import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { isNullOrUndefined } from "util";
import Button from "../../../../components/Button";
import IconButton from "../../../../components/IconButton";
import InputSelect from "../../../../components/Input-select";
import InputSelectMobile from "../../../../components/InputSelectMobile";
import Spinner from "../../../../components/Spinner";
import useAuthData from "../../../../hook/useAppData";
import { IconLeftArrowVersion2 } from "../../../../icons";
import { currentDate, _formatDate } from "../../../../libs/dateUtils";
import { ClientsUserId, TimeSheetProps } from "../../model";
import { getClientsUserId, getPointsByDay, getProjectsByClient } from "../../service";
import { TitleMobile } from "../components/TitleMobile";
import { ConfirmRegister } from "./ConfirmRegister";
import "./index.scss";
import Registered from "./Registered";
import { SelectClientAndProject } from "./SelectClientAndProject";

export type TypePages = "select" | "confirm" | "registered";
export type TypePoints = {
  clientId?: number;
  projectId: number;
  date: string;
  entrance: string | null;
  exit: string | null;
};

const initialize = {
  clientId: null,
  projectId: null,
  date: null,
  entrance: null,
  exit: null,
};

export function FormTimeSheetMobile() {
  const { token, userId } = useAuthData();
  const [listClient, setListClient] = useState([] as ClientsUserId[]);
  const [pages, setPages] = useState<TypePages>("select");
  const [project, setProject] = useState<any[]>();
  const [points, setPoints] = useState<TypePoints>();
  const [oldPoints, setOldPoints] = useState<TypePoints[]>();
  const [needSpinner, setNeedSpinner] = useState(true);
  const params = useParams<{ id?: string }>();

  useEffect(() => {
    getClientsUser();
  }, []);

  useEffect(() => {
    setNeedSpinner(true);
    setTimeout(() => {
      setNeedSpinner(false);
    }, 1000);
  }, [points]);

  async function getClientsUser(): Promise<void> {
    const data: ClientsUserId[] = await getClientsUserId(token);
    getProjectsByClients(data[0]?.id);
    setListClient(data);
  }

  async function getProjectsByClients(clientId: number) {
    const project = await getProjectsByClient(token, clientId);
    setProject(project);
    getAllPointsThisDate(clientId);
    return project;
  }

  async function getAllPointsThisDate(clientId = listClient[0]?.id, date = currentDate(), dateReceivedOfChild: boolean = false) {
    const datePoints: TimeSheetProps = await getPointsByDay(token, userId, params?.id || date);
    if (!datePoints?.points?.length) {
      setPoints({
        ...initialize,
        date: _formatDate(date),
        clientId: clientId,
        projectId: project[0]?.id,
      });
      return setNeedSpinner(false);
    }

    // find last point in datePoints, if he is null return object he, else return null
    const lastPoint = datePoints?.points?.find((point) => isNullOrUndefined(point?.exit));
    if (lastPoint?.entrance) {
      const res = await getProjectsByClient(token, lastPoint.clientId);
      setProject(res);
      setPages("confirm");
      setPoints({
        ...lastPoint,
        date: dateReceivedOfChild ? _formatDate(date?.replaceAll("/", "-")) : _formatDate(lastPoint?.date?.replaceAll("/", "-")),
      });
    }

    const allPointsWithoutIfLastNull = datePoints?.points?.filter((point) => !isNullOrUndefined(point?.exit));
    if (allPointsWithoutIfLastNull?.length) {
      setOldPoints(allPointsWithoutIfLastNull);
      const projects = await getProjectsByClient(token, allPointsWithoutIfLastNull[0].clientId);
      setProject(projects);
      if (!lastPoint?.entrance)
        setPoints({
          ...initialize,
          projectId: projects[0]?.id,
          clientId: allPointsWithoutIfLastNull[0]?.clientId,
          date: dateReceivedOfChild
            ? _formatDate(date?.replaceAll("/", "-"))
            : _formatDate(allPointsWithoutIfLastNull[0]?.date?.replaceAll("/", "-")),
        });
    }

    setNeedSpinner(false);
  }

  return (
    <>
      <div className="flex flex-col -mx-4 h-full">
        <div className="h-24 w-5/6">_</div>
        <div className="mr-8 flex-col h-full w-full px-8">
          <Spinner status={needSpinner} classNameFather="h-full">
            {pages === "select" && (
              <SelectClientAndProject
                listClient={listClient}
                project={project}
                setProject={setProject}
                setPages={() => setPages("confirm")}
                points={points}
                setPoints={setPoints}
              />
            )}
            {pages === "confirm" && (
              <ConfirmRegister
                setOldPoints={setOldPoints}
                setPages={setPages}
                points={points}
                setPoints={setPoints}
                oldPoints={oldPoints}
                getAllPointsThisDate={getAllPointsThisDate}
              />
            )}
            {pages === "registered" && <Registered />}
          </Spinner>
        </div>
      </div>
    </>
  );
}
